module.exports = __webpack_public_path__ + "static/img/apply6.b7e00bcf.png";